import { MISSING_LAZY_LOADING } from '../../../constants/rulesConstants';
import { $gfFrame } from '@/app/index';
import { app } from '@/store';
import type { ScreenType } from '../../../types';
import { getElementGroup, getImages } from '../../Engine/useGemMeterStore';

const MAX_IMAGE_SIZE = 300000;
const MAX_PAGE_IMAGES_SIZE = 1500000;

const DEFAULT_SIZE = {
  'hero-banner': 204000,
  parallax: 99200,
  image: 150000,
  'image-before-after': 52600,
};

export default class MissingLazyLoading {
  static ruleId = MISSING_LAZY_LOADING.id;

  static validate(screenType: ScreenType) {
    const advanceForm = app.$store.getters['page/advanceForm'];
    const elementGroups = getElementGroup() || {};
    const images = getImages();
    const elementGroupByRuleId = elementGroups[screenType][MISSING_LAZY_LOADING.id] || {};
    const keys = Object.keys(elementGroupByRuleId);
    if (keys.length === 0 || advanceForm.lazyLoad) {
      return true;
    }

    let isImagesOnPageValid = true;
    let totalSize = 0;
    let hasImageInvalid = true;
    try {
      keys.forEach((elId) => {
        const $element = $gfFrame().contents().find(elId);
        if (elementGroupByRuleId[elId].key === 'hero-banner' || elementGroupByRuleId[elId].key === 'parallax') {
          const selector = elementGroupByRuleId[elId].key === 'hero-banner' ? '' : '.gf_parallax-bg';
          const backgroundElement = selector ? $element.find(selector) : $element;
          const url = backgroundElement.css('background-image') || '';
          const src = url.replaceAll(`url("`, '').replaceAll(`")`, '');

          const size =
            images.find((item) => src.includes(item.id))?.size || DEFAULT_SIZE[elementGroupByRuleId[elId].key];
          if (size >= MAX_IMAGE_SIZE) {
            hasImageInvalid = false;
          }
          totalSize += size;
        }
        const $imageElements = $element.find('img');
        $imageElements.each((_, element) => {
          const src = element.src;
          const size =
            images.find((item) => src.includes(item.id))?.size || DEFAULT_SIZE[elementGroupByRuleId[elId].key];
          if (size >= MAX_IMAGE_SIZE) {
            hasImageInvalid = false;
          }
          totalSize += size;
        });
      });
    } catch (error) {}
    if (totalSize >= MAX_PAGE_IMAGES_SIZE) {
      isImagesOnPageValid = false;
    }

    return isImagesOnPageValid && hasImageInvalid;
  }
}
